import { render, staticRenderFns } from "./ListContainer.vue?vue&type=template&id=2564d66b&scoped=true"
import script from "./ListContainer.vue?vue&type=script&lang=js"
export * from "./ListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564d66b",
  null
  
)

export default component.exports